// extracted by mini-css-extract-plugin
export default {"container":"unsubscribe-page_container__0wPS8","messageContainer":"unsubscribe-page_messageContainer__gT9H4","message":"unsubscribe-page_message__cmoxd"};